import React, { useState } from 'react';
import styled from 'styled-components';
import { Checklist } from '@mui/icons-material';
import { INTERVIEW_PANEL_MODULE } from './const';
import { type SidebarData } from '../../components';
import { InterviewList } from './InterviewListPage';
import { AssessmentSidebar } from '../Assessment';
import { INTERVIEW_LIST_PAGE_TEXT } from './components';

export const InterviewPanelHome: React.FunctionComponent = () => {
  const [activatedModuleId, setActivatedModuleId] = useState(
    INTERVIEW_PANEL_MODULE.APPLICATION_LIST as INTERVIEW_PANEL_MODULE,
  );
  const handleChangeActivated = (activatedId: string): void => {
    setActivatedModuleId(activatedId as INTERVIEW_PANEL_MODULE);
  };

  const sidebarData: SidebarData[] = [
    {
      id: INTERVIEW_PANEL_MODULE.APPLICATION_LIST,
      name: INTERVIEW_LIST_PAGE_TEXT.INTERVIEW_LIST,
      icon: <Checklist />,
    },
  ];

  const assessmentModulesMap: Partial<
    Record<INTERVIEW_PANEL_MODULE, { component: any; moduleTitle: string }>
  > = {
    [INTERVIEW_PANEL_MODULE.APPLICATION_LIST]: {
      component: <InterviewList />,
      moduleTitle: INTERVIEW_LIST_PAGE_TEXT.INTERVIEW_LIST,
    },
  };

  const activatedModule:
    | { component: React.ReactNode; moduleTitle: string }
    | undefined = assessmentModulesMap[activatedModuleId];

  const moduleComponent = activatedModule?.component ?? activatedModuleId;
  const moduleTitle = activatedModule?.moduleTitle ?? activatedModuleId;

  return (
    <PageContainer>
      <div className="sidebar-area">
        <AssessmentSidebar
          onChangeActivated={handleChangeActivated}
          collapsible
          defaultOpen={false}
          currentActivatedModule={activatedModuleId}
          sidebarData={sidebarData}
          drawerWidth={200}
          drawerInnerWidth="12rem"
        />
      </div>
      <div className="flex flex-col w-full">
        <h1>{moduleTitle}</h1>
        <div className="ml-[1rem]">{moduleComponent}</div>
      </div>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  display: flex;
  flex-direction: row;
  h1 {
    margin-top: 1.5rem;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
    text-align: center;
    color: #951d1d;
  }
  .sidebar-area {
    width: min-content;
  }
`;
